import { handleActions } from 'redux-actions';
import { twilioActions } from '../actions/twilioActions';
const { twilioMakeCall, twilioMakeCallSucceeded, twilioMakeCallFailed, twilioMakeInternalCall, twilioMakeInternalCallSucceeded, twilioMakeInternalCallFailed, twilioMakeCallback, twilioMakeCallbackSucceeded, twilioMakeCallbackFailed, twilioConnectCall, twilioConnectCallSucceeded, twilioConnectCallFailed, twilioDisconnectCall, twilioDisconnectCallSucceeded, twilioDisconnectCallFailed, twilioFeedback, twilioFeedbackSucceeded, twilioFeedbackFailed, twilioFeedbackOpenModal, twilioFeedbackCloseModal, } = twilioActions;
// Init state for the twilio.
const initialState = {
    meta: {
        connectCall: 'succeeded',
        makeCall: 'succeeded',
        makeCallback: 'succeeded',
        internalCall: 'succeeded',
        disconnect: 'succeeded',
        feedback: 'succeeded',
    },
    ui: {
        isFeedbackModalOpen: false,
    },
};
// Reducer
export const twilio = handleActions({
    [twilioFeedbackOpenModal.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { ui: Object.assign(Object.assign({}, state.ui), { isFeedbackModalOpen: true }) });
    },
    [twilioFeedbackCloseModal.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { ui: Object.assign(Object.assign({}, state.ui), { isFeedbackModalOpen: false }) });
    },
    [twilioFeedback.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { feedback: 'loading' }) });
    },
    [twilioFeedbackSucceeded.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { feedback: 'succeeded' }) });
    },
    [twilioFeedbackFailed.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { feedback: 'failed' }) });
    },
    [twilioMakeCall.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { makeCall: 'loading' }) });
    },
    [twilioMakeCallSucceeded.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { makeCall: 'succeeded' }) });
    },
    [twilioMakeCallFailed.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { makeCall: 'failed' }) });
    },
    [twilioMakeCallback.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { makeCallback: 'loading' }) });
    },
    [twilioMakeCallbackSucceeded.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { makeCallback: 'succeeded' }) });
    },
    [twilioMakeCallbackFailed.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { makeCallback: 'failed' }) });
    },
    [twilioMakeInternalCall.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { internalCall: 'loading' }) });
    },
    [twilioMakeInternalCallSucceeded.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { internalCall: 'succeeded' }) });
    },
    [twilioMakeInternalCallFailed.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { internalCall: 'failed' }) });
    },
    [twilioConnectCall.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { connectCall: 'loading' }) });
    },
    [twilioConnectCallSucceeded.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { connectCall: 'succeeded' }) });
    },
    [twilioConnectCallFailed.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { connectCall: 'failed' }) });
    },
    [twilioDisconnectCall.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { disconnect: 'loading' }) });
    },
    [twilioDisconnectCallSucceeded.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { disconnect: 'succeeded' }) });
    },
    [twilioDisconnectCallFailed.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { disconnect: 'failed' }) });
    },
}, initialState);
